import { useQuery } from "@tanstack/react-query";
import { listOpenSessions } from "../api/sessions";

export function useSessionsOpen() {
  return useQuery({
    queryKey: ["tawa", "sessions", "open"],
    queryFn: listOpenSessions,
    // Vue partagée entre utilisateurs (qui est badgé). Resserré pour réduire le
    // lag cross-user : poll plus court + refetch au retour de focus onglet.
    staleTime: 5_000,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}
